module.exports = __webpack_public_path__ + "img/ico-emission-point.7edb83f9.svg";